import React from "react";
import Indus from "../Industries/Indus";
import Cards from "../Industries/Cards";

export default function IndustriesPage() {
    return (
        <>
            <Indus/>
            <Cards/>
        </>
    );
}